import { schema } from "normalizr";

import schoolSchema from "./schoolSchema";
import { SCHOOL_CLASS_SCHEMA } from "./index";

export default new schema.Entity(SCHOOL_CLASS_SCHEMA, {
  school: schoolSchema,
});
